import { RefObject } from 'react';

export default class MediaMethods {
  public static play(playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>) {
    if (playerRef.current instanceof HTMLAudioElement || playerRef.current instanceof HTMLVideoElement)
      playerRef.current?.play();
    else playerRef.current.internalPlayer.playVideo();
  }

  public static pause(playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>) {
    if (playerRef.current instanceof HTMLAudioElement || playerRef.current instanceof HTMLVideoElement)
      playerRef.current?.pause();
    else playerRef.current.internalPlayer.pauseVideo();
  }

  public static async skipTime(
    playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>,
    skipTime: number
  ) {
    if (playerRef.current instanceof HTMLAudioElement || playerRef.current instanceof HTMLVideoElement)
      playerRef.current!.currentTime = playerRef.current!.currentTime + skipTime;
    else playerRef.current.internalPlayer.seekTo((await MediaMethods.getCurrentTime(playerRef)) + skipTime);
  }

  /**
   * seekTo
   */
  public static seekTo(
    playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>,
    timestamp: number
  ) {
    if (playerRef.current instanceof HTMLAudioElement || playerRef.current instanceof HTMLVideoElement)
      playerRef.current!.currentTime = timestamp;
    else playerRef.current.internalPlayer.seekTo(timestamp);
  }

  public static setVolume(
    playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>,
    volume: string
  ) {
    if (playerRef.current instanceof HTMLAudioElement || playerRef.current instanceof HTMLVideoElement) {
      playerRef!.current!.volume = parseInt(volume) / 100;
    } else {
      playerRef.current.internalPlayer.setVolume(parseInt(volume));
    }
  }

  public static mute(playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>) {
    if (playerRef.current instanceof HTMLAudioElement || playerRef.current instanceof HTMLVideoElement) {
      playerRef!.current!.muted = true;
    } else {
      playerRef.current.internalPlayer.mute();
    }
  }

  public static unMute(playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>) {
    if (playerRef.current instanceof HTMLAudioElement || playerRef.current instanceof HTMLVideoElement) {
      playerRef!.current!.muted = false;
    } else {
      playerRef.current.internalPlayer.unMute();
    }
  }

  public static async getCurrentTime(
    playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>
  ): Promise<number> {
    if (playerRef.current instanceof HTMLAudioElement || playerRef.current instanceof HTMLVideoElement)
      return playerRef.current!.currentTime;
    else return await playerRef.current.internalPlayer.getCurrentTime();
  }

  public static getDuration(playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>) {
    if (playerRef.current instanceof HTMLAudioElement || playerRef.current instanceof HTMLVideoElement) {
      return playerRef.current!.duration;
    } else return playerRef.current.internalPlayer.getDuration();
  }

  public static updateCurrentTimeFromProgressBar(
    playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>,
    progressBarRef: RefObject<HTMLInputElement>,
    progressBarAndPlayerUpdater: () => void
  ) {
    if (playerRef.current instanceof HTMLAudioElement || playerRef.current instanceof HTMLVideoElement) {
      playerRef.current!.currentTime = parseInt(progressBarRef.current!.value);
    } else {
      playerRef.current.internalPlayer.seekTo(parseInt(progressBarRef.current!.value));
    }
    progressBarAndPlayerUpdater();
  }

  public static fullScreen(container: any, playerRef: RefObject<HTMLVideoElement> | RefObject<any>) {
    if (container.requestFullScreen) container.requestFullscreen();
    else if (container.mozRequestFullScreen) container.mozRequestFullScreen();
    else if (container.webkitRequestFullScreen) container.webkitRequestFullScreen();
    else if (container.msRequestFullscreen) container.msRequestFullscreen();

    if (playerRef.current instanceof HTMLVideoElement) {
      playerRef.current.height = window.screen.height;
      playerRef.current.width = window.screen.width;
    } else {
      playerRef.current.internalPlayer.setSize(window.screen.width, window.screen.height);
    }
  }

  public static exitFullScreen(videoRef: RefObject<HTMLVideoElement> | RefObject<any>) {
    if (document.exitFullscreen) document.exitFullscreen();
    //@ts-ignore
    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
    //@ts-ignore
    else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
    //@ts-ignore
    else if (document.msExitFullscreen) document.msExitFullscreen();

    if (videoRef.current instanceof HTMLVideoElement) {
      videoRef.current.height = 360;
      videoRef.current.width = 640;
    } else {
      videoRef.current.internalPlayer.setSize(640, 360);
    }
  }

  public static escapeKeyHandler(videoRef: RefObject<HTMLVideoElement> | RefObject<any>) {
    if (videoRef.current instanceof HTMLVideoElement) {
      videoRef.current.height = 360;
      videoRef.current.width = 640;
    } else {
      videoRef.current.internalPlayer.setSize(640, 360);
    }
  }

  /**
   * setPlaybackSpeed
   */
  public static setPlaybackSpeed(
    playerRef: RefObject<HTMLAudioElement> | RefObject<HTMLVideoElement> | RefObject<any>,
    speed: number
  ) {
    if (playerRef.current instanceof HTMLAudioElement || playerRef.current instanceof HTMLVideoElement)
      playerRef.current!.playbackRate = speed;
    else playerRef.current.internalPlayer.setPlaybackRate(speed);
  }

  public static convertSecondsToTime(seconds: number, description: boolean = false): string {
    const min = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, '0');

    const sec = Math.floor(seconds % 60)
      .toString()
      .padStart(2, '0');

    if (seconds > 3600) {
      const hours = Math.floor(seconds / 3600);
      if (description) return `${hours}h:${min}m:${sec}s`;
      else return `${hours}:${min}:${sec}`;
    } else {
      if (description) return `${min}m:${sec}s`;
      else return `${min}:${sec}`;
    }
  }
}
